import {connect} from 'react-redux';
import {isNil} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import {getRankProgression} from '/redux/action/coach.action';
import {
  nextRankIdById,
  rankProgressionByCoachAndRankIds,
} from '/redux/selector/coach.selector';
import {withProps} from '/util/selector.util';

import Detail from './Detail';

export default connect(
  createStructuredSelector({
    rankId: nextRankIdById,
    progressionData: withProps({
      rankId: nextRankIdById,
    })(rankProgressionByCoachAndRankIds),
  }),
  dispatch => ({
    getRankProgression: ({coachId, rankId}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(getRankProgression({coachId, rankId})),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    hasProgressionData: !isNil(stateProps.progressionData),
    getRankProgression: () =>
      dispatchProps.getRankProgression({
        coachId: ownProps.coachId,
        rankId: stateProps.rankId,
      }),
  }),
)(Detail);
